<template>
<!-- 总览 -->
  <div class="flowEcharts">
    <div class="flowCard">
      <div id="overViewCard"></div>
    </div>
    <div class="topcontent">
      <div class="flowTitle">
        <div>本月流量top100</div>
      </div>
      <div class="topTable">
        <!-- 表格 -->
        <DiluTable
          :list="tableData"
          :tableConfig="tableConfig"
          :total="total"
          :height="height"
          :pageSize="searchParams.pageSize"
        >
          <el-table-column prop="date" label="TOP" width="55" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="iccid" label="ICCID" align="center">
          </el-table-column>
          <el-table-column
            prop="usedFlow"
            label="本月使用流量(KB)"
            align="center"
          >
          </el-table-column>
        </DiluTable>
      </div>
    </div>                                                                                                                                                                              
  </div>
</template>

<script>
import * as echarts from "echarts";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
export default {
  data() {
    return {
      searchParams: {
        pageSize: 100,
      },
      summaryInfos: {},
      tableData: [],
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      height:"100%",
      total: 0,
      isSerch: false, //是否在查询
    };
  },
  mounted() {
    this.summaryInfo();
  },
  components: {
    DiluTable,
  },
  methods: {
    summaryInfo() {
      this.request.summaryInfo().then((res) => {
        this.tableData = res.data.top100;
        this.summaryInfos = res.data;
        var chartDom = document.getElementById("overViewCard");
        var myChart = echarts.init(chartDom);
        let echartsData = [];
        //if (this.summaryInfos.expired != 0) {
        echartsData.push({
          value: this.summaryInfos.expired,
          name: "欠费",
          itemStyle: { color: "#FF0000" },
        });
        //}
        //if (this.summaryInfos.normal != 0) {
          echartsData.push({
            value: this.summaryInfos.normal,
            name: "正常",
            itemStyle: { color: "#00FF00" },
          });
        //}
        //if (this.summaryInfos.will != 0) {
        echartsData.push({
          value: this.summaryInfos.will,
          name: "即将到期",
          itemStyle: { color: "#FF7f00" },
        });
        //}
        let count = echartsData.reduce((vs, v) => vs + v.value, 0);
        let formatNumber = (num) =>
          num.toString().replace(/(?=(\B)(\d{3})+$)/g, ",");
        var option;
        option = {
          tooltip: {
            trigger: "item",
            formatter: (p) =>
              `${p.marker}${p.data.name}<br>${p.marker}${p.value}     (${p.percent}%)`,
          },
          title: [
            {
              text: "物联卡状态数量",
              left: "center",
              top: "5%",
            },
            {
              text: `{val|${formatNumber(count)}}\n{name|卡总数}`,
              left: "center",
              top: "center",
              textStyle: {
                rich: {
                  name: {
                    fontSize: 16,
                    color: "#666666",
                  },
                  val: {
                    fontSize: 32,
                    fontWeight: "bold",
                    padding: [10, 0],
                    color: "#666666",
                  },
                },
              },
            },
          ],
          legend: {
            bottom: "5%",
            orient: "vertical",
            x: "right",
            y: "center",
          },
          series: [
            {
              type: "pie",
              radius: ["40%", "60%"],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                },
              },
              emphasis: {
                label: {
                  show: false,
                },
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    //自定义颜色
                    var colorList = [
                      "#00FF00",
                      "#FF0000",
                      "#FF7f00",
                    ];
                    return colorList[params.dataIndex];
                  },
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: echartsData,
            },
          ],
        };
        option && myChart.setOption(option);
      });
    },
    //流量卡折线图
    /* getFlowCard() {
      var myChart = echarts.init(document.getElementById("overViewCards"));
      myChart.setOption({
        title: {
          text: "本月每日流量",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            areaStyle: {
              color: "#40C6B0",
              opacity: 0.5,
            },
            itemStyle: {
              normal: {
                borderColor: "#40C6B0", // 拐点边框颜色
                lineStyle: {
                  color: "#40C6B0",
                  width: 5, // 设置线宽
                  type: "solid", //'dotted'虚线 'solid'实线
                },
              },
            },
          },
        ],
      });
    }, */
  },
};
</script>

<style scoped>
.flowCard {
  width: 100%;
}
.topcontent {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.flowTitle {
  font-size: 18px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #5f5e5e;
  margin-bottom: 10px;
}
.flowEcharts {
  overflow-y: auto;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}
/* .flowCards {
  width: 70%;
} */
#overViewCard {
  width: 40%;
  height: 300px;
}
.topTable {
  display: flex;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
/* #overViewCards {
  width: 100%;
  height: 300px;
} */
</style>